import type { HistoryArchiveStatus } from '../../../services/dmMonitoringOverviewHistory';
import { CardErrorState } from '../../accounts/overview/CardErrorState';
import { ChartSkeleton } from '../../shared/ChartSkeleton';
import { InfoHint } from '../../billing/overview/OverviewCard';
import { ArchiveFailedNote, ARCHIVE_NOT_CONNECTED } from './OverviewRangeBar';
import { OVER_TIME_CHART_HEIGHT_PX, OverTimeChart } from './OverTimeChart';
import { hasCounts, type OverTimeChartData } from './overTimeRows';
import { EmptyNote } from './StackedBar';

export function WindowSubtitle({
    label,
    archive
}: {
    label: string;
    archive?: HistoryArchiveStatus;
}) {
    return (
        <span className="flex flex-wrap items-center gap-x-1.5 text-[11px] text-gray-400">
            {label}
            {archive === 'not_configured' && <InfoHint text={ARCHIVE_NOT_CONNECTED} />}
            {archive === 'failed' && <ArchiveFailedNote />}
        </span>
    );
}

interface OverTimeBodyProps {
    chart: OverTimeChartData | null;
    isLoading: boolean;
    isSwitching: boolean;
    errorMessage: string | null;
    emptyMessage: string;
    onRetry: () => void;
}

export function OverTimeBody(props: OverTimeBodyProps) {
    const { chart, isLoading, isSwitching, errorMessage, emptyMessage, onRetry } = props;
    if (chart && hasCounts(chart)) {
        return (
            <div className={`transition-opacity ${isSwitching ? 'opacity-60' : ''}`}>
                <OverTimeChart chart={chart} />
            </div>
        );
    }
    return (
        <div className="grid place-items-center" style={{ height: OVER_TIME_CHART_HEIGHT_PX }}>
            {isLoading ? (
                <div className="h-full w-full">
                    <ChartSkeleton />
                </div>
            ) : errorMessage ? (
                <CardErrorState message={errorMessage} onRetry={onRetry} />
            ) : (
                <EmptyNote>{emptyMessage}</EmptyNote>
            )}
        </div>
    );
}
